import { createAsyncThunk } from '@reduxjs/toolkit';

const getAuthNew = async (_args, { extra: { http } }) => {
  try {
    return await http.get(`/auth/new`);
  } catch {}
};

const postAuth = async ({ email, password, otp }, { extra: { http } }) => {
  try {
    const authPayload = {};
    authPayload['email'] = email;
    authPayload['password'] = password;
    if (otp) {
      authPayload['otp'] = otp;
    }
    return await http.post(`/auth`, {
      auth: authPayload,
    });
  } catch {}
};

export const onlogout = async (_args, { extra: { http } }) => {
  try {
    return http.delete(`/auth/refresh`);
  } catch {}
};

export const fetchLogin = createAsyncThunk('auth/new/fetch', getAuthNew);
export const login = createAsyncThunk('auth/login', postAuth);
export const logout = createAsyncThunk('auth/logout', onlogout);
